import React, { useEffect } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";

export function UnityPlayer(props: any) {
  const baseLocation = "https://devassets.vleader.net/unity/";


  const loaderHash = 'dc840f5fa491f9224446f665d5ce7bc9.loader', dataHash = '1ee93079c78cd5c2ee469143ad5878bc', frameworkHash = 'c5147124b378b3d5a9b36fd262ad1b57.framework', codeHash = 'e0097cbebbe798a0c831113b2640ab35';

  const { unityProvider, loadingProgression, isLoaded, sendMessage, addEventListener, removeEventListener } = useUnityContext({
    loaderUrl: baseLocation + loaderHash + ".js",
    dataUrl: baseLocation + dataHash + ".data",
    frameworkUrl: baseLocation + frameworkHash + ".js",
    codeUrl: baseLocation + codeHash + ".wasm",
  });

  useEffect(()  => {
    props.bindSendMessage(sendMessage);
  }, [sendMessage]);

  useEffect(() => {
    props.progressChange(loadingProgression);
  }, [loadingProgression]);

  useEffect(() => {
    if (isLoaded === true) {
      props.onLoaded();
    }
  }, [isLoaded])

  useEffect(() => {
    addEventListener("pushToWindow", props.pushToWindow);
    return () => {
      removeEventListener("pushToWindow", props.pushToWindow);
    };
  }, []);

  return (
    <div style={{width: '100%', height: '100%', display: 'flex'}}>
      <Unity style={{width: '100%', height: '100%', display: 'flex'}} className="inner-unity" unityProvider={unityProvider} />
    </div>
  );
}
